import React from 'react';
import AvatarDI from '@atlaskit/avatar';
import { CustomHeader as HeaderDI } from '../../common/ui/custom-header/index.tsx';
import type { ProjectHeaderProps } from './types.tsx';

export const ProjectHeader = ({
	Avatar = AvatarDI,
	Header = HeaderDI,
	avatarUrl,
	iconBefore,
	description,
	name,
}: ProjectHeaderProps) => {
	return (
		<Header
			description={description}
			iconBefore={
				iconBefore ?? (
					<Avatar
						appearance="square"
						borderColor="transparent"
						size="small"
						src={avatarUrl ? `${avatarUrl}?size=xxlarge` : avatarUrl}
					/>
				)
			}
		>
			{name}
		</Header>
	);
};
